// extracted by mini-css-extract-plugin
export default {"addressOption":"address-suggestion-form__addressOption__Z6Fok"};